export default __webpack_public_path__ + "locales/tr/Webhooks.json?hash=b5234cc3b028b81acb7173c07dee6c24";